import React, { Component } from "react";
import { connect } from "react-redux";
import { Button } from '../../ui';
import mailImage from '../../../assets/common/mail.png';
import { clean } from '../../../actions';
import SendEmailWrapper from './SendEmail.style';

class SendEmail extends Component {

  render() {
    const { name, quoteAccepted, apply, restart } = this.props;
    return (
      <SendEmailWrapper>
        <div className="SendEmail-container">
          <div className="SendEmail-container-image">
            <img className="SendEmail-image" src={mailImage} alt="mailImage" />
          </div>
          { !quoteAccepted &&
            <p className="SendEmail-text">
              {name ? name + ', te ' : 'Te '} enviamos un mail con la cotización que elegiste, podés hacer uso de ella cuando quieras!
            </p>
          }
          { quoteAccepted &&
            <p className="SendEmail-text">
              {name ? name + ', un ' : 'Un '} ejecutivo de cuenta de SURA Seguros Uruguay se pondrá en contacto contigo a la brevedad {apply ? 'para finalizar la compra' : ''}. Muchas gracias!
            </p>
          }
          <div className="SendEmail-button-container">
            <Button onClick={() => {restart()}}>Volver a cotizar</Button>
          </div>
        </div>
      </SendEmailWrapper>
    );
  }
}

SendEmail.defaultProps = {
  quoteAccepted: false,
  apply: true,
};

const mapStateToProps = (state, ownProps) => {
  return {
    name: state.client.name,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    restart: () => {
      dispatch(clean());
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SendEmail);